import {
	getApiAccessFailureMessageForResource,
	getEmptyResponseAccessMessageForResource,
} from '@/components/access-control/routeAccessMessages'
import type { ResourceId } from '@/config/access-control'
import type { Permissions } from '@/rbac/grants'
import { isPlatformUser } from '@/stores/auth'
import { useAuthStore } from '@/stores/authStore'
import { useCallback, useMemo } from 'react'

/**
 * Resolves user-facing copy when list APIs return empty data or 403, using `/me` role grants.
 */
export function usePageAccessMessages(resource: ResourceId | undefined) {
	const user = useAuthStore(s => s.user)
	const permissions = useMemo(
		(): Permissions | undefined => (isPlatformUser(user) ? user.role?.permissions : undefined),
		[user],
	)

	const emptyListMessage = useCallback(
		(isEmpty: boolean) => (resource ? getEmptyResponseAccessMessageForResource(resource, permissions, isEmpty) : null),
		[permissions, resource],
	)

	const forbiddenMessage = useCallback(
		(status: number) => (resource ? getApiAccessFailureMessageForResource(status, resource, permissions) : null),
		[permissions, resource],
	)

	return { permissions, emptyListMessage, forbiddenMessage }
}
